export const technologies = [
    { 
        name: 'JavaScript',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'
    },
    {
        name: 'HTML',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg'
    },
    { 
        name: 'CSS',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg'
    },
    { 
        name: 'PHP',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg'
    },
    { 
        name: 'jQuery',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-original-wordmark.svg'
    },
    {
        name: 'Tailwindcss',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg'
    },
    {
        name: 'WordPress',
        src: 'https://raw.githubusercontent.com/pheralb/svgl/8df82e2e2aeeda02d6c858ad752a6cb044d4954a/static/library/wordpress.svg'
    },
    {
        name: 'MySQL',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg'
    },
    {
        name: 'Elementor',
        src: 'https://raw.githubusercontent.com/pheralb/svgl/874876fc8e737beb2405971bc917d1f2cb50a765/static/library/elementor.svg'
    },
    {
        name: 'WooCommerce',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/woocommerce/woocommerce-original.svg'
    },
    {
        name: 'Divi',
        src: 'https://raw.githubusercontent.com/pheralb/svgl/d6d12456d84f1bdb756532100b7246f622ea35e9/static/library/divi.svg'
    },
    {
        name: 'React',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
    },
    { 
        name: 'VueJS',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg'
    },
    {
        name: 'TypeScript',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg'
    },
    { 
        name: 'NodeJS',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg'
    },
    { 
        name: 'Laravel',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg'
    },    
    {
        name: 'Bootstrap',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original-wordmark.svg'
    },
    {
        name: 'Git',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg'
    },
    {
        name: 'Apache',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original-wordmark.svg'
    },
    {
        name: 'Bash',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg'
    },
    {
        name: 'Ubuntu',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/ubuntu/ubuntu-original-wordmark.svg'
    },
    { 
        name: 'ExpressJS',
        src: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg'
    }
]
